export default __webpack_public_path__ + "static/media/Image2.7dade17a.png";